export default __webpack_public_path__ + "static/media/mother_day_background.5e8491cf.webp";